import { DataSource, DataSourceMode, DataSourceModeChangeEvent, ParentSearchMode, Table } from "@mcleod/components";
import { AutogenLayoutQuoteFreightItemTable } from "./autogen/AutogenLayoutQuoteFreightItemTable";

export class QuoteFreightItemTable extends AutogenLayoutQuoteFreightItemTable {

    onLoad() {
        this.layoutFreightItemTable.tableDataSource = this.sourceQuoteFreightGroupItem;
    }

    public set doBeforeCommoditySearch(callback: (filter: any) => void) {
        this.layoutFreightItemTable.doBeforeCommoditySearch = callback;
    }

    public get tableFreightItems(): Table {
        return this.layoutFreightItemTable.tableFreightItems;
    }

    public set sourceQuote(sourceQuote: DataSource) {
        this.sourceQuoteFreightGroupItem.parentDataSource = sourceQuote;
        this.sourceQuoteFreightGroupItem.parentSearchMode = ParentSearchMode.onParentDisplay;
        sourceQuote.addAfterModeChangeListener((event: DataSourceModeChangeEvent) => {
            this.sourceQuoteFreightGroupItem.mode = event.newMode;
            if (event.newMode == DataSourceMode.ADD) {
                this.layoutFreightItemTable.addFreightItemToTable();
            }
        })
    }

    public set showDetails(value: boolean) {
        this.layoutFreightItemTable.showDetails = value;
    }

    validateBeforePost(): boolean {
        return this.layoutFreightItemTable.validateBeforePost();
    }

}
